module.exports = __webpack_public_path__ + "assets/img/chronicleImg-06238e3c.png";